// extracted by mini-css-extract-plugin
module.exports = {"snackbar_wrapper":"snackbar_snackbar_wrapper__01sAw","show":"snackbar_show___nLQh","snackbar_text":"snackbar_snackbar_text__M8SDd"};